<div>
    <!-- Titulo Entrenamientos -->
    <div class="flex items-center justify-center w-full m-5 text-center animate-fade">
        <h1 class="text-lg sm:text-xl md:text-3xl text-azul font-bold">
            {{ 'entrenamientos' | translate }}
        </h1>
    </div>

    <!-- Boton Registrar Nueva Sesion Entrenamiento -->
     <div *ngIf="cuerpoTecnico && cuerpoTecnico.tipo === 'entrenador'" class="m-5 animate-fade-left">
        <button (click)="registrarNuevaSesionEntrenamiento()" class="bg-azul text-white p-2 cursor-pointer rounded-lg hover:text-blue-300 duration-1000">
            {{'registrar-nueva-sesion' | translate }}
        </button>
    </div>

    <!-- Contenedor Informacion Entrenamientos -->
    <div class="p-3 animate-fade-up">
        <mat-accordion>
            <mat-expansion-panel *ngFor="let sesion of sesionesEntrenamiento" (opened)="cargarEntrenamientosSesion(sesion.ID)">
                <mat-expansion-panel-header class="bg-gray-400">
                    <mat-panel-title>
                        <div class="text-azul flex items-center gap-2">
                            <mat-icon class="invisible md:visible">fitness_center</mat-icon>
                            <p class="text-base">{{'sesion-entrenamiento' | translate}}</p>
                        </div>
                    </mat-panel-title>
                    <mat-panel-description class="text-black">
                        <span class="hidden md:inline">{{'fecha-inicio' | translate}}</span>
                        <span>{{ sesion.FechaInicio | date: 'dd/MM/yy'}}</span>
                    </mat-panel-description>
                    <mat-panel-description class="text-black">
                        <span class="hidden md:inline"> {{'fecha-fin' | translate}}:</span>
                        <span>{{ sesion.FechaFin | date: 'dd/MM/yy'}}</span>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <!-- Contenedor con la informacion de los detalles de la sesion -->
                <mat-panel-description>
                    <div class="flex flex-wrap gap-6 p-5 mt-3" *ngIf="sesion.DetallesSesion">
                        <div *ngFor="let detalle of sesion.DetallesSesion; let i = index">
                            <div class="border-2 bg-white border-azul rounded-lg shadow-lg shadow-gray-600 animate-fade
                                transition duration-300 ease-in-out hover:-translate-y-2">
                                <p class="text-white text-base text-center p-2 bg-azul">{{'entrenamiento' | translate}} {{i + 1}}</p>
                                <div class="p-3">
                                    <!-- Tipo Entrenamiento -->
                                    <div class="text-azul flex items-start gap-2 text-sm sm:text-base mb-1">
                                        <mat-icon>sports</mat-icon>
                                        <p class="text-black">{{'tipo' | translate}}: {{detalle.entrenamiento?.tipo?.toUpperCase()}}</p>
                                    </div> 
                                    <!-- Fecha Entrenamiento -->
                                    <div class="text-azul flex items-start gap-2 text-sm sm:text-base mb-1">
                                        <mat-icon>event</mat-icon>
                                        <p class="text-black">{{'fecha' | translate}} {{detalle.fecha | date: 'mediumDate'}}</p>
                                    </div> 
                                    <!-- Duracion Entrenamiento -->
                                    <div class="text-azul flex items-start gap-2 text-sm sm:text-base mb-1">
                                        <mat-icon>schedule</mat-icon>
                                        <p class="text-black">{{'duracion' | translate}}: {{detalle.entrenamiento?.duracion}}</p>
                                    </div>
                                    <!-- Descripcion Entrenamiento -->
                                    <div class="text-azul flex items-start gap-2 text-sm sm:text-base mb-1">
                                        <mat-icon>description</mat-icon>
                                        <p class="text-black">{{'descripcion' | translate}} {{detalle.entrenamiento?.descripcion}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>
